import React from 'react';
import { GlobeIcon, LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
import { CheckList } from './CheckList';
type Props = {
  ribbon?: string;
  heading?: string;
  subheading?: string;
  includesTitle?: string;
  includes?: readonly string[];
  ctaLabel: string;
  ctaSub: string;
  showCompare?: boolean;
};
export function OfferBox({
  ribbon = 'Your complete collection',
  heading,
  subheading,
  includesTitle,
  includes,
  ctaLabel,
  ctaSub,
  showCompare = true
}: Props) {
  return <div className="mx-auto w-full max-w-xl overflow-hidden rounded-3xl bg-white shadow-card ring-4 ring-gold" data-id="element-359" data-mp="1u7ls439m2f3o">
      <div className="bg-gold px-4 py-3 text-center font-display text-sm font-black uppercase tracking-wide text-ink" data-id="element-360" data-mp="1p8qxm42a723q">
        {ribbon}
      </div>
      <div className="px-5 pb-7 pt-6 md:px-8" data-id="element-361" data-mp="1f99tvs6layae">
        {heading && <h3 className="text-balance text-center font-display text-2xl font-black leading-tight text-heading md:text-3xl" data-id="element-362" data-mp="1fa1ph306sw0o">
            {heading}
          </h3>}
        {subheading && <p className="mt-2 text-center text-[16px] text-body" data-id="element-363" data-mp="3gl5i53ym033m">{subheading}</p>}

        <div className="mt-5 flex flex-col items-center" data-id="element-364" data-mp="31vr5nmzql5k0">
          {showCompare && <p className="text-lg font-bold text-body" data-id="element-365" data-mp="36szsw1zqrzs4">
              Total value: <span className="text-danger line-through decoration-2" data-id="element-366" data-mp="3ujdkxsibtymp">$180</span>
            </p>}
          <p className="mt-1 flex items-start font-display font-black leading-none text-heading" data-id="element-367" data-mp="3csotudf00it">
            <span className="mt-3 text-3xl" data-id="element-368" data-mp="3klfxv8c7e7vo">$</span>
            <span className="text-[88px] tracking-tight" data-id="element-369" data-mp="3kknzxqv4vy28">27</span>
            <span className="mt-4 pl-1 text-xl" data-id="element-370" data-mp="3pjhihxpa2f99">USD</span>
          </p>
          <span className="mt-2 rounded-full bg-success px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-371" data-mp="2960sph9uc9ph">
            One-time payment
          </span>
        </div>

        {includes && <div className="mt-7 rounded-2xl bg-paper p-5" data-id="element-372" data-mp="km4xg5jmy9en">
            {includesTitle && <p className="mb-4 font-display text-base font-extrabold uppercase text-heading" data-id="element-373" data-mp="ko7ngpksg2jd">{includesTitle}</p>}
            <CheckList items={includes} data-id="element-374" data-mp="awbpdeipccf5" />
          </div>}

        <div className="mt-7" data-id="element-375" data-mp="auqrbex6ibcj">
          <CTAButton label={ctaLabel} sub={ctaSub} tone="light" data-id="element-376" data-mp="5xs0p6cq4mj3" />
        </div>

        <div className="mt-6 space-y-6" data-id="element-377" data-mp="5vnyqtydxxlg">
          <Countdown data-id="element-378" data-mp="ynr4elw0ms8" />
          <ScarcityBar data-id="element-379" data-mp="zywujyw84lz" />
        </div>

        <div className="mt-6 space-y-2 border-t border-line pt-5 text-sm text-body" data-id="element-380" data-mp="3t27w5lsrsnqu">
          <p className="flex items-start gap-2" data-id="element-381" data-mp="3t4axh1zdi3av">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-blue" aria-hidden="true" data-id="element-382" data-mp="3o2buht7jp8eg" />
            <span data-id="element-383" data-mp="3j4k453mjtucd">
              <strong className="text-heading" data-id="element-384" data-mp="3j5bxe7sobfzh">Automatic currency conversion:</strong> the price converts to your local currency at checkout.
            </span>
          </p>
          <p className="flex items-start gap-2" data-id="element-385" data-mp="1hc5mm5nx2rwh">
            <LockIcon className="mt-0.5 h-4 w-4 shrink-0 text-blue" aria-hidden="true" data-id="element-386" data-mp="1hdgn9wm2fjjd" />
            <span data-id="element-387" data-mp="1ovn7bmcwdnum">Secure checkout · Digital product · No recurring subscription</span>
          </p>
        </div>
      </div>
    </div>;
}